import type { Selection } from 'react-aria-components';
import { Flex, Text } from '@backstage/ui';
import { ToggleButton, ToggleButtonGroup } from 'react-aria-components';

import styles from './ProjectScorecards.module.css';
import { CheckSegments } from './CheckSegments';
import { useScorecardsFilter } from './ScorecardsFilterContext';

const toStringSet = (sel: Selection): Set<string> => {
  if (sel === 'all') return new Set<string>();
  return new Set([...sel].map(String));
};

interface TrackFiltersProps {
  trackStats: Map<
    string,
    { name: string; passing: number; failing: number; total: number }
  >;
}

export const TrackFilters = ({ trackStats }: TrackFiltersProps) => {
  const { activeCategories, setActiveCategories } = useScorecardsFilter();
  return (
    <ToggleButtonGroup
      selectionMode="multiple"
      selectedKeys={activeCategories}
      onSelectionChange={keys => setActiveCategories(toStringSet(keys))}
      className={styles.categoriesRow}
      aria-label="Filter by track"
    >
      {[...trackStats.entries()].map(([trackId, stats]) => (
        <ToggleButton
          key={trackId}
          id={trackId}
          className={styles.categoryCard}
        >
          <Flex
            align="center"
            justify="between"
            className={styles.categoryHeader}
          >
            <Text
              as="span"
              variant="body-small"
              weight="bold"
              className={styles.categoryName}
            >
              {stats.name}
            </Text>
            <Text
              as="span"
              variant="body-small"
              color="secondary"
              className={styles.categoryCount}
            >
              {stats.passing}/{stats.total}
            </Text>
          </Flex>
          <CheckSegments
            passing={stats.passing}
            failing={stats.failing}
            total={stats.total}
          />
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};
